import { BASE_SITE_CONTEXT_ID, SiteContextConfig } from '@spartacus/core';
import {
  COUNTRY_CONTEXT_ID,
  CURRENCY_CONTEXT_ID,
  LANGUAGE_CONTEXT_ID,
} from './context-ids';

export function defaultSiteContextConfigFactory(): SiteContextConfig {
  return {
    context: {
      [COUNTRY_CONTEXT_ID]: ['US', 'CA', 'MX'],
      [LANGUAGE_CONTEXT_ID]: ['en', 'fr_CA', 'es_MX'],
      [CURRENCY_CONTEXT_ID]: ['USD', 'CAD', 'MXN'],
      [BASE_SITE_CONTEXT_ID]: ['NA']
    },
  };
}
